import { html, attr, type Signal, When } from '@tempots/dom'
import { Button, Icon } from '@tempots/beatui'

export interface ExecuteButtonOptions {
  executing: Signal<boolean>
  onExecute: () => void
}

export function ExecuteButton({ executing, onExecute }: ExecuteButtonOptions) {
  return html.div(
    attr.class('bg-gray-50 rounded-lg p-4 mb-4 flex items-end'),
    Button(
      {
        fullWidth: true,
        disabled: executing,
        onClick: onExecute,
      },
      html.span(
        attr.class('flex items-center justify-center gap-2'),
        When(
          executing,
          () =>
            Icon({ icon: 'mdi:loading' }, attr.class('w-4 h-4 animate-spin')),
          () => Icon({ icon: 'mdi:play-circle' }, attr.class('w-4 h-4'))
        ),
        executing.map((e) => (e ? 'Executing...' : 'Execute'))
      )
    )
  )
}
